import { FC } from 'react';
import styled from 'styled-components';
import { theme } from '../theme';

const TextElement = styled.span<IProps>`
  font-size: ${props => props.size || 16}px;
  color: ${props => getColor(props)};
  font-weight: ${props => getFontWeight(props)};
  overflow: hidden;
  text-overflow: ellipsis;
`;

type TextVariation = 'normal' | 'primary' | 'secondary' | 'tertiary' | 'link' | 'error';
type TextWeight = 'normal' | 'medium' | 'bold';

interface IProps {
  variation?: TextVariation;
  weight?: TextWeight;
  size?: number;
}

/** @deprecated Do not use. Use `P` or `Span` instead */
export const Text: FC<IProps> = props => (
  <TextElement variation={props.variation} size={props.size} weight={props.weight}>
    {props.children}
  </TextElement>
);

function getColor(props) {
  switch (props.variation) {
    case 'primary':
    case 'link':
      return theme.vars.newColor.blue2;
    case 'secondary':
      return theme.vars.color.pink;
    case 'tertiary':
      return theme.vars.newColor.darkGS2;
    case 'error':
      return theme.vars.newColor.red2;
    default:
      return theme.vars.newColor.darkGS1;
  }
}

function getFontWeight(props: IProps) {
  switch (props.weight) {
    case 'medium':
      return '400';
    case 'bold':
      return '600';
    case 'normal':
    default:
      return '300';
  }
}
